import { defaultHttpClient } from '../../httpClient';

export const getRepresentativeImageRedirectPath = (params: {
  goods_sno?: number;
  market_sno?: number;
  entry_point?: string;
  product_type?: string;
}) => {
  return defaultHttpClient
    .request<{
      resource_image: {
        image_url: string;
        width: number;
        height: number;
      } | null;
      deeplink: string | null;
      logging: { analytics: object } | null;
    }>({
      method: 'GET',
      url: '/ai-studio/representative-images/redirect-path/',
      params,
    })
    .then(result => result.data);
};
